export default "__VITE_ASSET__B5tAgO7S__"